import * as $http from 'axios'

export default {
    refundReasons: () => $http.get('center/get_refund_reason'),
    refundReasonsLater: () => $http.get('center/get_refund_reason_later'),
    refundExcludes: () => $http.get('center/get_refund_exclude'),
    faqInfo: () => $http.get('center/get_faq_info?role=user'),
    loadReason: () => $http.get('center/load_reason?role=user'),
}
